import styled from '@emotion/styled';
import { IBilling } from 'domain/entities/Billing/Billing';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import dayjs from 'dayjs';
import { mqUser } from 'utils/responsive';

const Wrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
        font-size: var(--font-small);
    }
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-radius: 10px;
    overflow: hidden;
    background-color: var(--white);
    margin-bottom: 50px;
`;

const TableHeader = styled.th`
    padding: 10px;
    background-color: var(--main-font-color);
    border: 1px solid var(--gray);
    text-align: left;
    border-radius-top-left: 10px;
    color: var(--white);
    font-size: var(--font-medium);
`;

const TableRow = styled.tr`
    &:nth-of-type(even) {
        background-color: var(--light-gray);
    }

    &:first-child td,
    &:first-child td:nth-of-type(2) {
        white-space: nowrap;
    }
`;

const TableCell = styled.td`
    padding: 10px;
`;

export const HistoryTable: React.FC<{ billingList: IBilling[] }> = ({ billingList }) => {
    return (
        <Wrapper>
            <PageTitle title="請求履歴" />
            {billingList.length === 0 ? (
                <p>請求履歴はありません</p>
            ) : (
                <Table>
                    <thead>
                        <tr>
                            <TableHeader>日付</TableHeader>
                            <TableHeader>金額</TableHeader>
                            <TableHeader>内容</TableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {billingList.map((billing) => (
                            <TableRow key={billing.id}>
                                <TableCell>{dayjs(billing.billing_at).format('YYYY-MM-DD')}</TableCell>
                                <TableCell>{`¥ ${billing.amount.toLocaleString()}`}</TableCell>
                                <TableCell>{billing.reason}</TableCell>
                            </TableRow>
                        ))}
                    </tbody>
                </Table>
            )}
        </Wrapper>
    );
};
